export const selectAll = (checkboxes, checked) => {
    checkboxes.forEach(checkbox => {
        checkbox.checked = checked;
    });
};

export const createVerifyDeterminationCallback = (checkboxes, headerCheckbox) => () => {
    let accumulator = null;

    headerCheckbox.indeterminate = checkboxes.some(checkbox => {
        if (accumulator === null) {
            accumulator = checkbox.checked;
            return false;
        }

        return accumulator !== checkbox.checked;
    });
    headerCheckbox.checked = checkboxes.every(c => c.checked);
};

export const createCheckboxClickHandler = (checkbox, verifyDeterminationCallback) => event => {
    const row = checkbox.closest('tr');
    const tableBody = row.closest('tbody');
    const tableRows = Array.from(tableBody.children);
    const previousIndex = tableBody.lastCheckedIndex ?? null;

    tableBody.lastCheckedIndex = tableRows.indexOf(row);

    // bail out, this is not a range select request
    if (previousIndex === null || !event.shiftKey || previousIndex === tableBody.lastCheckedIndex) {
        verifyDeterminationCallback();
        return;
    }

    const checkState = tableRows[previousIndex].querySelector('input[type="checkbox"]').checked;

    // do not toggle the original target again
    const range = {
        start: previousIndex > tableBody.lastCheckedIndex ? tableBody.lastCheckedIndex : previousIndex + 1,
        end: previousIndex < tableBody.lastCheckedIndex ? tableBody.lastCheckedIndex : previousIndex - 1
    };

    tableRows.forEach((row, index) => {
        if (index < range.start || index > range.end) {
            return;
        }

        row.querySelector('input[type="checkbox"]').checked = checkState;
    });

    verifyDeterminationCallback();
};
